import React from 'react';
import Img from 'img';
import Container from 'container';
import s from './ad-a.module.scss';

export default function AdA({ image, href, ...props }) {
  return (
    <a href={href} className={s.root}>
      <div className={s.imgWrapper}>
        <Img className={s.img} src={image} alt={image.title} />
      </div>
    </a>
  );
}
